import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ImageAnchoredParagraphStyles = makeStyles((theme) => ({
  container: {
    padding: "40px 60px",
    fontFamily: "Inter, sans-serif",
    "& a": {
      textDecoration: "underline",
      color: COLORS.ACCENT2,
      fontWeight: 600
    },
    "& img": {
      objectFit: "cover"
    }
  },
  anchorImage: { height: 290, width: 295, borderRadius: 4 },
  textContainer: { paddingLeft: 15 },
  header: {}
}));

export default ImageAnchoredParagraphStyles;
